const baseRoutes = [
  {
    path: 'menu/members',
    component: () => import("@/_routes/tabs/menu/members/Root"),
  },
  {
    path: 'menu/members/partition',
    component: () => import("@/_routes/tabs/menu/members/PartitionMembers")
  },
  {
    path: 'menu/members/partition/add',
    component: () => import("@/_routes/tabs/menu/members/AddPartitionMember")
  },
  {
    path: 'menu/members/:memberId',
    component: () => import("@/_routes/tabs/menu/members/Member")
  },
  {
    path: 'menu/members/:memberId/permission',
    component: () => import("@/_routes/tabs/menu/members/Permission")
  },
]

const routes = baseRoutes

export default routes
